import { EnvironmentProviders, Provider } from '@angular/core';
import { abiosConfigName } from '@bcf-v2-configurators/tokens/abios/letsbetmd/abios-config-name';
import { ABIOS_CONFIG_NAME } from '@bcf-v2-configurators/tokens/abios/token';
import { applePayByPiqPaymentMethodEnabled } from '@bcf-v2-configurators/tokens/applepay/letsbetmd/applepay-by-piq-enabled';
import { APPLEPAY_BY_PIQ_PAYMENT_METHOD_ENABLED } from '@bcf-v2-configurators/tokens/applepay/token';
import { possibleWinningAboveWinTresholdMode } from '@bcf-v2-configurators/tokens/betslip/letsbetmd/possible-winning-above-win-treshold-mode';
import { possibleWinningMax } from '@bcf-v2-configurators/tokens/betslip/letsbetmd/possible-winning-max';
import {
  POSSIBLE_WINNING_ABOVE_WIN_TRESHOLD_MODE,
  POSSIBLE_WINNING_MAX,
  QUICK_APPLEPAY_PNM_IN_BETSLIP_ENABLED
} from '@bcf-v2-configurators/tokens/betslip/token';
import { CMS_LP_BADGE_STATE } from '@bcf-v2-configurators/tokens/cms-lp-badge-state/token';
import { CMS_LP_HERO_TITLE_SIZE } from '@bcf-v2-configurators/tokens/cms-lp-hero-title-size/token';
import { dateFormat } from '@bcf-v2-configurators/tokens/date-format/letsbetmd/date-format';
import { fullDateFormat } from '@bcf-v2-configurators/tokens/date-format/letsbetmd/full-date-format';
import { myBetsListItemDateFormat } from '@bcf-v2-configurators/tokens/date-format/letsbetmd/my-bets-list-item-date-format';
import { preMatchesGroupDateFormat } from '@bcf-v2-configurators/tokens/date-format/letsbetmd/pre-matches-group-date-format';
import { timeFormat } from '@bcf-v2-configurators/tokens/date-format/letsbetmd/time-format';
import { timeFormatOptions } from '@bcf-v2-configurators/tokens/date-format/letsbetmd/time-format-options';
import { userPanelDateFormat } from '@bcf-v2-configurators/tokens/date-format/letsbetmd/user-panel-date-format';
import { userPanelDateTimeFormat } from '@bcf-v2-configurators/tokens/date-format/letsbetmd/user-panel-date-time-format';
import {
  DATE_FORMAT,
  FULL_DATE_FORMAT,
  MY_BETS_LIST_ITEM_DATE_FORMAT,
  PRE_MATCHES_GROUP_DATE_FORMAT,
  TIME_FORMAT,
  TIME_FORMAT_OPTIONS,
  USER_PANEL_DATE_FORMAT,
  USER_PANEL_DATE_TIME_FORMAT
} from '@bcf-v2-configurators/tokens/date-format/token';
import { I18N_OPTIMOVE_DESC_LOADER } from '@bcf-v2-configurators/tokens/descs-optimove-i18n/token';
import { I18N_DESC_LOADER } from '@bcf-v2-configurators/tokens/descs/token';
import { editProfileAddressAvailableFieldsFn } from '@bcf-v2-configurators/tokens/edit-profile/lvbetcom/edit-profile-available-fields';
import { EDIT_PROFILE_ADDRESS_AVAILABLE_FIELDS } from '@bcf-v2-configurators/tokens/edit-profile/token';
import { footerBrandName } from '@bcf-v2-configurators/tokens/footer/letsbetmd/footer-brand-name';
import { footerLinksFn } from '@bcf-v2-configurators/tokens/footer/letsbetmd/footer-links';
import { spSidebarLinksFn } from '@bcf-v2-configurators/tokens/footer/letsbetmd/sp-sidebar-links';
import { FOOTER_BRAND_NAME, FOOTER_LINKS, SP_SIDEBAR_LINKS } from '@bcf-v2-configurators/tokens/footer/token';
import { googleMapsApiToken } from '@bcf-v2-configurators/tokens/google-autocomplete/letsbetmd/google-maps-api-token';
import { GOOGLE_MAPS_API_KEY } from '@bcf-v2-configurators/tokens/google-autocomplete/token';
import { imgWebConfig } from '@bcf-v2-configurators/tokens/img-webp/letsbetmd/img-web-config';
import { IMG_WEB_CONFIG } from '@bcf-v2-configurators/tokens/img-webp/token';
import { LANGUAGE_SWITCHER_FLAG_MAP } from '@bcf-v2-configurators/tokens/language-switcher/token';
import { usaLanguageSwitcherFlagMap } from '@bcf-v2-configurators/tokens/language-switcher/usa/usa-language-switcher-flag-map';
import { lotteryBrandName } from '@bcf-v2-configurators/tokens/lottery/lvbet/lottery-brand-name';
import { LOTTERY_BRAND_NAME } from '@bcf-v2-configurators/tokens/lottery/token';
import { lotteryAssetsUrlValue } from '@bcf-v2-configurators/tokens/lv-wheel/letsbetmd/lottery-assets-url';
import { lvWheelConfig } from '@bcf-v2-configurators/tokens/lv-wheel/letsbetmd/lv-wheel-config';
import { LV_WHEEL_CONFIG } from '@bcf-v2-configurators/tokens/lv-wheel/token';
import { lvisionBetBoosterApiKeys } from '@bcf-v2-configurators/tokens/lvision-bet-booster/letsbetmd/lvision-bet-booster-api-keys';
import { LVISION_BET_BOOSTER_API_KEYS } from '@bcf-v2-configurators/tokens/lvision-bet-booster/token';
import { oddsFormatDefault } from '@bcf-v2-configurators/tokens/match-offer/letsbetmd/odds-format-default';
import { primaryColumnSettingsMode } from '@bcf-v2-configurators/tokens/match-offer/letsbetmd/primary-column-settings-mode';
import { watchAndBetEnabled } from '@bcf-v2-configurators/tokens/match-offer/letsbetmd/watch-and-bet-enabled';
import {
  LIVE_MATCH_IN_CARD_STYLE_ENABLED,
  MATCH_VIZU_WATCH_AND_BET_ENABLED,
  ODDS_FORMAT_DEFAULT,
  ODDS_FORMAT_SWITCHER,
  PRIMARY_COLUMN_SETTINGS_MODE,
  USA_KIND_STYLE_ODDS_ENABLED
} from '@bcf-v2-configurators/tokens/match-offer/tokens';
import { mobileApplicationAppConfig } from '@bcf-v2-configurators/tokens/mobile-application/sportsbook/letsbetmd/config';
import { MOBILE_APPLICATION_APPS_CONFIG } from '@bcf-v2-configurators/tokens/mobile-application/token';
import { commonTaxPayoutDetailsInfo } from '@bcf-v2-configurators/tokens/my-bets/letsbetmd/common-tax-payout-details-info';
import { customTaxPayoutDetailsInfo } from '@bcf-v2-configurators/tokens/my-bets/letsbetmd/custom-tax-payout-details-info';
import {
  COMMISSION_ENABLED,
  COMMON_TAX_PAYOUT_DETAIL_INFO,
  CUSTOM_TAX_PAYOUT_DETAIL_INFO,
  EDIT_ENABLED
} from '@bcf-v2-configurators/tokens/my-bets/token';
import { OPTIMOVE_SDK_CONFIG_LOADER } from '@bcf-v2-configurators/tokens/optimove-sdk/tokens';
import { PUSH_NOTIFICATIONS_CONFIG_LOADER } from '@bcf-v2-configurators/tokens/push-notifications/token';
import { RG_LIMITS_PARALLEL_TIME_VALUES_API_KIND } from '@bcf-v2-configurators/tokens/rg-limits-parallel/token';
import { sportsImagesAssetsUrl } from '@bcf-v2-configurators/tokens/sports/letsbetmd/sports-images-assets-url';
import {
  SPORTSBOOK_BET_BUILDER_PRESENTATION,
  SPORTS_IMAGES_ASSETS_URL
} from '@bcf-v2-configurators/tokens/sports/token';
import { statscoreVizuConfig } from '@bcf-v2-configurators/tokens/statscore-vizu-config/letsbetmd/statscore-vizu-config';
import { STATSCORE_VIZU_CONFIG } from '@bcf-v2-configurators/tokens/statscore-vizu-config/token';
import { USE_US_SPORT_ICONS } from '@bcf-v2-configurators/tokens/us-sport-icons/token';
import { bonusesFreeSpinsEnabled } from '@bcf-v2-configurators/tokens/user-bonuses/letsbetmd/bonuses-free-spins-enabled';
import { BONUSES_FREE_SPINS_ENABLED } from '@bcf-v2-configurators/tokens/user-bonuses/token';
import { provideVanillaTsTokens } from '@bcf-v2-shared/misc/vanilla-ts-providers/provide-vanilla-ts-tokens';
import { logRocketApiKey } from '@bcf-vanilla-ts-v1-configurators/tokens/log-rocket/letsbetmd/log-rocket-api-key';
import { registerLogRocketApiKey } from '@bcf-vanilla-ts-v1-configurators/tokens/log-rocket/token';
import { LOTTERY_ASSETS_URL } from '@bcf-vanilla-ts-v1-configurators/tokens/lottery/token';
import { rgLimitsParallelTimeValuesApiKind } from '@bcf-vanilla-ts-v1-configurators/tokens/rg-limits-parallel/letsbetmd/rg-limits-parallel-time-values-api-kind';

export const settingsProviders: (Provider | EnvironmentProviders)[] = [
  {
    provide: IMG_WEB_CONFIG,
    useValue: imgWebConfig
  },
  {
    provide: I18N_DESC_LOADER,
    useValue: () =>
      import(
        /* webpackChunkName: "const-i18n-desc" */ '@bcf-v2-configurators/tokens/descs/letsbetmd/mobile-web/i18n-desc'
        // eslint-disable-next-line @typescript-eslint/typedef
      ).then((mod) => mod.i18nDesc)
  },
  {
    provide: USA_KIND_STYLE_ODDS_ENABLED,
    useValue: true
  },
  {
    provide: ODDS_FORMAT_SWITCHER,
    useValue: true
  },
  {
    provide: LIVE_MATCH_IN_CARD_STYLE_ENABLED,
    useValue: false
  },
  {
    provide: ODDS_FORMAT_DEFAULT,
    useValue: oddsFormatDefault
  },
  {
    provide: PRIMARY_COLUMN_SETTINGS_MODE,
    useValue: primaryColumnSettingsMode
  },
  {
    provide: MATCH_VIZU_WATCH_AND_BET_ENABLED,
    useValue: watchAndBetEnabled
  },
  {
    provide: MOBILE_APPLICATION_APPS_CONFIG,
    useValue: mobileApplicationAppConfig
  },
  {
    provide: LANGUAGE_SWITCHER_FLAG_MAP,
    useValue: usaLanguageSwitcherFlagMap
  },
  {
    provide: EDIT_PROFILE_ADDRESS_AVAILABLE_FIELDS,
    useValue: editProfileAddressAvailableFieldsFn
  },
  {
    provide: RG_LIMITS_PARALLEL_TIME_VALUES_API_KIND,
    useValue: rgLimitsParallelTimeValuesApiKind
  },
  {
    provide: STATSCORE_VIZU_CONFIG,
    useValue: statscoreVizuConfig
  },
  {
    provide: ABIOS_CONFIG_NAME,
    useValue: abiosConfigName
  },
  {
    provide: BONUSES_FREE_SPINS_ENABLED,
    useValue: bonusesFreeSpinsEnabled
  },
  {
    provide: USER_PANEL_DATE_FORMAT,
    useValue: userPanelDateFormat
  },
  {
    provide: USER_PANEL_DATE_TIME_FORMAT,
    useValue: userPanelDateTimeFormat
  },
  {
    provide: GOOGLE_MAPS_API_KEY,
    useValue: googleMapsApiToken
  },
  {
    provide: POSSIBLE_WINNING_ABOVE_WIN_TRESHOLD_MODE,
    useValue: possibleWinningAboveWinTresholdMode
  },
  {
    provide: POSSIBLE_WINNING_MAX,
    useValue: possibleWinningMax
  },
  {
    provide: DATE_FORMAT,
    useValue: dateFormat
  },
  {
    provide: FULL_DATE_FORMAT,
    useValue: fullDateFormat
  },
  {
    provide: TIME_FORMAT_OPTIONS,
    useValue: timeFormatOptions
  },
  {
    provide: TIME_FORMAT,
    useValue: timeFormat
  },
  {
    provide: PRE_MATCHES_GROUP_DATE_FORMAT,
    useValue: preMatchesGroupDateFormat
  },
  {
    provide: MY_BETS_LIST_ITEM_DATE_FORMAT,
    useValue: myBetsListItemDateFormat
  },
  {
    provide: FOOTER_LINKS,
    useValue: footerLinksFn
  },
  {
    provide: SP_SIDEBAR_LINKS,
    useValue: spSidebarLinksFn
  },
  {
    provide: FOOTER_BRAND_NAME,
    useValue: footerBrandName
  },
  {
    provide: CMS_LP_BADGE_STATE,
    useValue: 'primary'
  },
  {
    provide: CMS_LP_HERO_TITLE_SIZE,
    useValue: 32
  },
  {
    provide: PUSH_NOTIFICATIONS_CONFIG_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/push-notifications/letsbetmd/push-notifications-config').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.pushNotificationsConfigs
      )
  },
  {
    provide: OPTIMOVE_SDK_CONFIG_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/optimove-sdk/letsbetmd/mobile-web/optimove-sdk-config').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.optimoveSdkConfigs
      )
  },
  {
    provide: I18N_OPTIMOVE_DESC_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/descs-optimove-i18n/letsbetmd/sportsbook/i18n-optimove-desc').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.i18nOptimoveDesc
      )
  },
  {
    provide: LVISION_BET_BOOSTER_API_KEYS,
    useValue: lvisionBetBoosterApiKeys
  },
  {
    provide: COMMISSION_ENABLED,
    useValue: false
  },
  {
    provide: COMMON_TAX_PAYOUT_DETAIL_INFO,
    useValue: commonTaxPayoutDetailsInfo
  },
  {
    provide: CUSTOM_TAX_PAYOUT_DETAIL_INFO,
    useValue: customTaxPayoutDetailsInfo
  },
  {
    provide: LV_WHEEL_CONFIG,
    useValue: lvWheelConfig
  },
  {
    provide: LOTTERY_ASSETS_URL,
    useValue: lotteryAssetsUrlValue
  },
  {
    provide: USE_US_SPORT_ICONS,
    useValue: true
  },
  {
    provide: LOTTERY_BRAND_NAME,
    useValue: lotteryBrandName
  },
  {
    provide: SPORTS_IMAGES_ASSETS_URL,
    useValue: sportsImagesAssetsUrl
  },
  {
    provide: EDIT_ENABLED,
    useValue: false
  },
  {
    provide: SPORTSBOOK_BET_BUILDER_PRESENTATION,
    useValue: 'tag'
  },
  provideVanillaTsTokens(() => {
    registerLogRocketApiKey(logRocketApiKey);
  }),
  {
    provide: QUICK_APPLEPAY_PNM_IN_BETSLIP_ENABLED,
    useValue: true
  },
  {
    provide: APPLEPAY_BY_PIQ_PAYMENT_METHOD_ENABLED,
    useValue: applePayByPiqPaymentMethodEnabled
  }
];
